import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import toast from 'react-hot-toast'

const Register: React.FC = () => {
  const { register } = useAuth()
  const navigate = useNavigate()
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', phone: '', password: '', confirm: '' })
  const [loading, setLoading] = useState(false)

  const set = (key: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm((prev) => ({ ...prev, [key]: e.target.value }))

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (form.password.length < 8) {
      toast.error('رمز عبور باید حداقل ۸ کاراکتر باشد')
      return
    }
    if (form.password !== form.confirm) {
      toast.error('تکرار رمز عبور مطابقت ندارد')
      return
    }
    setLoading(true)
    try {
      await register({
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        phone: form.phone || undefined,
        password: form.password
      })
      toast.success('ثبت‌نام با موفقیت انجام شد')
      navigate('/')
    } catch (err: any) {
      toast.error(err?.response?.data?.message || err.message || 'خطا در ثبت‌نام')
    } finally {
      setLoading(false)
    }
  }

  const inputCls = 'input'

  return (
    <div className="container-main flex justify-center py-14">
      <div className="w-full max-w-lg">
        <div className="card p-8">
          <h1 className="text-2xl font-black text-gray-900 text-center mb-1">ساخت حساب کاربری</h1>
          <p className="text-sm text-gray-500 text-center mb-6">برای ثبت سفارش خرید و فروش، حساب بسازید</p>

          <form onSubmit={submit} className="space-y-4">
            <div className="grid sm:grid-cols-2 gap-4">
              <div>
                <label className="label">نام *</label>
                <input className={inputCls} value={form.firstName} onChange={set('firstName')} required />
              </div>
              <div>
                <label className="label">نام خانوادگی *</label>
                <input className={inputCls} value={form.lastName} onChange={set('lastName')} required />
              </div>
            </div>
            <div>
              <label className="label">ایمیل *</label>
              <input type="email" className={inputCls} dir="ltr" placeholder="you@example.com" value={form.email} onChange={set('email')} required />
            </div>
            <div>
              <label className="label">شماره موبایل (اختیاری)</label>
              <input className={inputCls} dir="ltr" placeholder="09xxxxxxxxx" value={form.phone} onChange={set('phone')} />
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <div>
                <label className="label">رمز عبور (حداقل ۸ کاراکتر) *</label>
                <input type="password" className={inputCls} dir="ltr" value={form.password} onChange={set('password')} required />
              </div>
              <div>
                <label className="label">تکرار رمز عبور *</label>
                <input type="password" className={inputCls} dir="ltr" value={form.confirm} onChange={set('confirm')} required />
              </div>
            </div>
            <button className="btn btn-primary w-full !py-3 disabled:opacity-50" disabled={loading}>
              {loading ? 'در حال ثبت‌نام…' : 'ثبت‌نام'}
            </button>
          </form>

          <p className="text-sm text-gray-500 text-center mt-6">
            حساب دارید؟{' '}
            <Link to="/login" className="text-primary-600 font-bold hover:underline">وارد شوید</Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Register